import React, { useEffect, useState, useCallback } from "react";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { useSnackbar } from "notistack";
import { useDispatch, useSelector } from "react-redux";
import { useCurrencySymbol } from "../../../../../utils/currencyUtils";
import CommaConvert from "../../../../../utils/CommaConvert";
import {
  formatAmountComma,
  formatAmountForInput,
  validateAmountValue,
  parseAmountNumber,
} from "../../../../../utils/decimalAmountUtils";
import { getAllAutoSaveWorkentries } from "../../../../../store/slices/autosaveSlice";
import { submitWorkEntries } from "../../../../../store/slices/Entries&DescriptionSubmitByOm";
import { fetchDescriptionTasks } from "../../../../../store/slices/DescriptionTask";
import { replaceAllDescriptionTasks } from "../../../../../store/slices/descriptionTaskSlice";
import { replaceAllHardwareDescriptions } from "../../../../../store/slices/hardwareDescriptionSlice";
import { fetchHardware } from "../../../../../store/slices/hardwareSlice";
import { updateTaskStatus } from "../../../../../store/slices/projectTaskStatusSlice";
import AdminLoader from "../../../../../components/common/loader/AdminLoader";
import SubmitLoader from "../../../../../components/common/loader/SubmitLoader";
import { getAllAssemblyInventory } from "../../../../../store/slices/assemblyInventorySlice";
import { fetchGroups } from "../../../../../store/slices/groupSlice";
import {
  collapseTrainingBundlesToSingleRowPerAssignee,
  consolidateTrainingExpenseRowsForDisplay,
  getTrainingExpenseBundlesForManagerResource,
  isTrainingExpenseDisplayRow,
  mergeTrainingExpenseRowsInto,
  normalizeDescriptionTaskWireEntry,
  taskProjectIdMatchesOpsManagerResourceScopes,
} from "../../../../../utils/trainingOtherExpenseSync";

/** Local UI rule (Hardware manager → OPS person Other Expenses only): treat training lines last; include description heuristic for legacy payloads. */
function isHardwareManagerTrainingExpenseUiRow(expenseRow) {
  return isTrainingExpenseDisplayRow(expenseRow);
}

function orderHardwareOpsPersonOtherExpenseRows(rows) {
  const list = ([]).concat(rows || []).filter(Boolean);
  return consolidateTrainingExpenseRowsForDisplay(list);
}

const OperationHardware = ({
  setSelectedActions,
  opemail,
  selectedemail,
  selectedServiceType,
  managerOPID,
  managerOPProject,
  row,
  Action,
  setAction,
  hardwareAction,
  setHardwareAction,
  employees,
  tasks,
  items,
  hardwareData,
  handlerefresh,
  taskTableRowId,
}) => {
  console.log("OperationHardware selectedemail", selectedemail)

  const [filteredEntries, setFilteredEntries] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  const currency = useCurrencySymbol();
  const USAComma = CommaConvert();

  const dispatch = useDispatch();
  const { autosaveentries } = useSelector((state) => state.autosave);
  const { projects } = useSelector((state) => state.projects);
  const { mytrainings } = useSelector((state) => state.myTrainings);
  const [isLoadingtask, setisLoadingtask] = useState(false);
  const [typingTimeout, setTypingTimeout] = React.useState(null);
  const [tripduration, setTripDuration] = useState("");
  const [isLoading, SetisLoading] = useState(false);
  const [Assignperson, setAssignperson] = useState("");
  const [totalDollerValue, settotalDollerValue] = useState(0);
  const [currentAssignperson, setcurrentAssignperson] = useState("");
  const [hardware, setHardware] = useState([
    {
      assemblepartdescription: "",
      partno: "",
      quantity: "",
      unitprice: "",
      totalprice: "",
    },
  ]);
  const { inventory } = useSelector((state) => state.assemblyInventory);
  const { group: groups } = useSelector((state) => state.group);
  const groupNameById = React.useMemo(() => {
    const map = new Map();
    (groups || []).forEach((g) => {
      const id = g?._id || g?.id;
      const name = g?.newGroupName || g?.groupname || g?.groupName || g?.name || "";
      if (id && name) map.set(String(id), name);
    });
    return map;
  }, [groups]);
  const selectedGroupName = React.useMemo(() => {
    const groupId = row?.groupid?._id || row?.groupid;
    if (groupId && groupNameById.has(String(groupId))) {
      return groupNameById.get(String(groupId));
    }
    return row?.AssignedGroup || "";
  }, [row, groupNameById]);

  const projectGroupId = React.useMemo(() => {
    return String(
      row?.groupid?._id ||
        row?.groupid?.id ||
        row?.groupid ||
        row?.groupId?._id ||
        row?.groupId?.id ||
        row?.groupId ||
        ""
    );
  }, [row]);

  const isInventoryGroupMatch = useCallback(
    (entry) => {
      const inventoryGroupId = String(
        entry?.groupid?._id ||
          entry?.groupid?.id ||
          entry?.groupid ||
          entry?.groupId?._id ||
          entry?.groupId?.id ||
          entry?.groupId ||
          ""
      );

      if (projectGroupId && inventoryGroupId) {
        return projectGroupId === inventoryGroupId;
      }

      if (selectedGroupName) {
        return entry?.group === selectedGroupName;
      }

      return false;
    },
    [projectGroupId, selectedGroupName]
  );


  useEffect(() => {
    if (row && row.Assignedperson) {
      const assignedPerson = row.Assignedperson.find(
        (person) => person.email === opemail
      );
      setAssignperson(assignedPerson);
    }
  }, [row, opemail]);
  // Only set default tab when the project row changes (row._id), not on every re-render,
  // so clicking "Other Expenses" is not overwritten by this effect.
  useEffect(() => {
    const hasHardware = Array.isArray(selectedServiceType)
      ? selectedServiceType.some((service) => service.includes("Hardware"))
      : selectedServiceType?.includes("Hardware");

    if (hasHardware) {
      setAction("");
      setHardwareAction("hardwarecost");
    } else {
      setAction("task");
      setHardwareAction("");
    }
  }, [row?._id, setAction, selectedServiceType, setHardwareAction]);

  useEffect(() => {
    if (hardware.length === 0) {
      setHardware([
        {
          assemblepartdescription: "",
          partno: "",
          quantity: "",
          unitprice: "",
          totalprice: "",
        },
      ]);
    }
  }, [hardware, setHardware]);

  const [filteredPersonDescription, setFilteredPersonDescription] = useState(
    []
  );

  const [fetchedHardwareData, setfetchedHardwareData] = useState([]);
  // useEffect(() => {
  //   const userEmail = localStorage?.getItem("email");
  //   const currentEmployee = employees?.find(
  //     (emp) => emp.EmpEmail === userEmail
  //   );
  //   const matchedtaskEntries = hardwareData.filter(
  //     (entry) =>
  //       entry.group === row?.AssignedGroup &&
  //       entry.createdBy === currentEmployee?._id
  //   );
  //   const newhardwareRows = matchedtaskEntries?.map((hardware) => ({
  //     _id: hardware._id,
  //     assemblepartdescription: hardware.assembly || "",
  //     partnumber: hardware.partnumber || "",
  //     unitprice: hardware.unitprice || "",
  //   }));

  //   setfetchedHardwareData(newhardwareRows);
  // }, [hardwareData, employees, row]);
  useEffect(() => {
    // Assembly dropdown: show only assemblies whose group matches the project's AssignedGroup
    const matchedtaskEntries = inventory.filter((entry) =>
      isInventoryGroupMatch(entry)
    );
    
    const newhardwareRows = matchedtaskEntries?.map((hardware) => ({
      _id: hardware._id,
      assemblepartdescription: hardware.assembly || "",
      partnumber: hardware.partnumber || "",
      unitprice: hardware.unitprice || "",
    }));
    setfetchedHardwareData(newhardwareRows)
  }, [hardwareData, inventory, employees, row, isInventoryGroupMatch]);


  useEffect(() => {
    const emNorm = String(selectedemail || "").trim().toLowerCase();
    const currentEmployee = (employees || []).find(
      (emp) => String(emp?.EmpEmail || "").trim().toLowerCase() === emNorm
    );
    console.log("OperationHardware currentEmployee", currentEmployee)

    if ((currentEmployee || row) && items) {
      const filteredHardware = items?.filter(
        (item) =>
          String(item?.taskownerid ?? "") === String(currentEmployee?._id ?? "") &&
          String(item?.projectid ?? "").trim() === String(row?._id ?? "").trim()
      );
      setFilteredEntries(filteredHardware);
      console.log("OperationHardware filteredHardware", filteredHardware)
      if (filteredHardware?.length > 0 || filteredHardware.length === 0) {
        setHardware(
          filteredHardware?.length > 0
            ? filteredHardware
            : [
              {
                assemblepartdescription: "",
                partno: "",
                quantity: "",
                unitprice: "",
                totalprice: "",
                taskownerid: currentEmployee._id,
              },
            ]
        );
      }
    }
  }, [items, selectedemail, row, employees]);

  useEffect(() => {
    const emNorm = String(selectedemail || "").trim().toLowerCase();
    const currentEmployee = (employees || []).find(
      (emp) => String(emp?.EmpEmail || "").trim().toLowerCase() === emNorm
    );

    setcurrentAssignperson(currentEmployee?._id);

    if (!currentEmployee?._id) {
      setFilteredPersonDescription([]);
      return;
    }

    const ownerId = String(currentEmployee._id);
    const matchedTasks = tasks.filter(
      (task) =>
        String(task?.taskownerid ?? "") === ownerId &&
        taskProjectIdMatchesOpsManagerResourceScopes(task, row, managerOPProject)
    );

    if (matchedTasks.length) {
      setTripDuration(matchedTasks[0]?.tripduration ?? "");
    }
    setFilteredPersonDescription(matchedTasks);
  }, [tasks, managerOPID, employees, managerOPProject, selectedemail, row]);

  useEffect(() => {
    dispatch(getAllAutoSaveWorkentries());
    dispatch(getAllAssemblyInventory());
    dispatch(fetchGroups());
  }, [dispatch]);

  const [triprows, setTripRows] = useState([
    { description: "", value: "", notes: "" },
  ]);
  const [initialEdit, setInitialEdit] = useState(false);

  useEffect(() => {
    if (initialEdit) return;

    const raw = ([]).concat(filteredPersonDescription || []).filter(Boolean);
    const ordered = orderHardwareOpsPersonOtherExpenseRows(raw);
    setTripRows(
      ordered.length > 0
        ? ordered
        : [{ description: "", value: "", notes: "" }]
    );
    const total = ordered.reduce((sum, r) => sum + (parseFloat(r.value) || 0), 0);
    settotalDollerValue(total);
  }, [filteredPersonDescription, initialEdit]);

  const trainingExpenseRowSurfaceStyle = {
    backgroundColor: "#f3f4f6",
    opacity: 0.85,
    color: "#6b7280",
  };

  const lastEditableTripRowIndex = React.useMemo(() => {
    for (let i = triprows.length - 1; i >= 0; i -= 1) {
      if (!isHardwareManagerTrainingExpenseUiRow(triprows[i])) return i;
    }
    return -1;
  }, [triprows]);

  const handledirectSubmit = async () => {
    const filteredEmployee = employees.find(
      (emp) => emp?.EmpEmail === selectedemail
    );
    const projectid = row._id;
    const taskownerid = filteredEmployee?._id;

    if (!taskownerid && !projectid) {
      return;
    }
    try {
      await dispatch(submitWorkEntries({ projectid, taskownerid }));
    } catch (error) {
      console.error("Failed to create task:", error);
    } finally {
      handlerefresh();
    }
  };

  const handleDescriptionSubmit = React.useCallback(
    async (updatedRows) => {
      const rowsPayload = ([]).concat(
        updatedRows != null ? updatedRows : triprows
      );
      const filteredRows = rowsPayload?.filter((r) => {
        return (
          (r.description && r.description.trim() !== "") ||
          (r.value && r.value.toString().trim() !== "") ||
          (r.notes && r.notes.trim() !== "")
        );
      });

      const resourceTrainingBundles = collapseTrainingBundlesToSingleRowPerAssignee(
        getTrainingExpenseBundlesForManagerResource({
          trainingsEnvelope: mytrainings,
          employees,
          projects,
          selectedEmail: selectedemail,
          opemail,
          row,
          managerOPProject,
        })
      );

      // Always continue so empty lists persist as [] and clear stale Other Expenses on resubmit

      let defaultTypeService =
        filteredRows?.length > 0 ? filteredRows[0]?.typeservice : "";
      defaultTypeService = Array.isArray(defaultTypeService)
        ? defaultTypeService.find(Boolean) || ""
        : defaultTypeService;
      defaultTypeService =
        String(defaultTypeService || "").trim() ||
        String(Array.isArray(row?.TypeService) ? row.TypeService?.[0] : row?.TypeService ?? "").trim();

      const projectid = row._id;

      setisLoadingtask(true);
      try {
        const manualOnly =
          filteredRows?.filter((r) => !isHardwareManagerTrainingExpenseUiRow(r)) || [];
        const formdata = manualOnly.map((r) => ({
          description: r.description,
          notes: r.notes,
          typeservice: r.typeservice || defaultTypeService,
          value: r.value,
          taskstatus: "submit",
          tripduration: r.tripduration,
        }));

        const mergedFlat = mergeTrainingExpenseRowsInto(
          formdata || [],
          resourceTrainingBundles
        ).map((r) =>
          normalizeDescriptionTaskWireEntry({
            ...r,
            typeservice: r.typeservice ?? defaultTypeService,
          })
        );

        await dispatch(
          replaceAllDescriptionTasks({
            projectid: projectid,
            taskownerid: currentAssignperson,
            tasktype: "other",
            entries: mergedFlat,
          })
        );
      } catch (error) {
        console.error("Operation failed:", error);
      } finally {
        setisLoadingtask(false);
        setInitialEdit(false);
        dispatch(fetchDescriptionTasks());
      }
    },
    [
      dispatch,
      currentAssignperson,
      row,
      triprows,
      employees,
      projects,
      mytrainings,
      selectedemail,
      opemail,
      managerOPProject,
    ]
  );

  const handleTripInputChange = (index, field, value) => {
    // Clear any existing timeout
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }
    setInitialEdit(true);
    setTripRows((prevRows) => {
      if (isHardwareManagerTrainingExpenseUiRow(prevRows[index])) return prevRows;
      const newRows = [...prevRows];
      if (field === "value") {
        const total = orderHardwareOpsPersonOtherExpenseRows(newRows).reduce(
          (sum, rr) => sum + parseAmountNumber(rr.value),
          0
        );
        settotalDollerValue(total);
      }
      // Apply different validation based on field type
      let validatedValue;
      if (field === "value") {
        validatedValue = validateAmountValue(value);
      } else {
        validatedValue = validateDescriptionOrNotes(value);
      }

      newRows[index] = {
        ...newRows[index],
        [field]: validatedValue,
      };

      // Set new timeout for auto-submit
      const newTimeout = setTimeout(() => {
        handleDescriptionSubmit(orderHardwareOpsPersonOtherExpenseRows(newRows));
      }, 2000);

      setTypingTimeout(newTimeout);
      return orderHardwareOpsPersonOtherExpenseRows(newRows);
    });
  };

  // Improved validation functions
  const validateDescriptionOrNotes = (value) => {
    return value.replace(/[^a-zA-Z0-9 .,?'-]/g, "");
  };


  const handleAddRow = () => {
    if (triprows.length < 15) {
      setInitialEdit(true);
      const next = orderHardwareOpsPersonOtherExpenseRows([
        ...triprows,
        { description: "", value: "", notes: "" },
      ]);
      setTripRows(next);
    } else {
      enqueueSnackbar("You can only add up to 15 rows.", { variant: "error" });
    }
  };

  const handleRemoveRow = (index) => {
    if (isHardwareManagerTrainingExpenseUiRow(triprows[index])) {
      return;
    }
    setInitialEdit(true);
    const updatedRows = orderHardwareOpsPersonOtherExpenseRows(
      triprows.filter((_, i) => i !== index)
    );
    const total = updatedRows?.reduce((sum, r) => {
      return sum + (parseFloat(r.value) || 0);
    }, 0);
    settotalDollerValue(total);
    setTripRows(updatedRows);
    setTimeout(() => {
      handleDescriptionSubmit(updatedRows);
    }, 2000);
  };

  useEffect(() => {
    const currentEmployee = employees.find((emp) => emp.EmpEmail === opemail);

    if (currentEmployee && managerOPProject) {
      const filteredEntries = autosaveentries.filter(
        (entry) =>
          entry.projectid === managerOPProject?._id &&
          entry.taskownerid === currentEmployee._id
      );
      setFilteredEntries(filteredEntries);
    } else {
      console.error(
        "No matching employee found or acceptedProject not available"
      );
    }
  }, [autosaveentries, managerOPProject, opemail, employees]);

  const handleinstallationtaskSubmit = React.useCallback(
    async (numericValue, newRows) => {
      const rowsPayload = orderHardwareOpsPersonOtherExpenseRows(
        ([]).concat(newRows != null ? newRows : triprows)
      );
      const filteredRows = rowsPayload?.filter((r) => {
        return (
          (r.description && r.description.trim() !== "") ||
          (r.value && r.value.toString().trim() !== "") ||
          (r.notes && r.notes.trim() !== "")
        );
      });

      const resourceTrainingBundles = collapseTrainingBundlesToSingleRowPerAssignee(
        getTrainingExpenseBundlesForManagerResource({
          trainingsEnvelope: mytrainings,
          employees,
          projects,
          selectedEmail: selectedemail,
          opemail,
          row,
          managerOPProject,
        })
      );

      // Always continue so empty lists persist as [] and clear stale Other Expenses on resubmit

      let defaultTypeService =
        filteredRows?.length > 0 ? filteredRows[0]?.typeservice : "";
      defaultTypeService = Array.isArray(defaultTypeService)
        ? defaultTypeService.find(Boolean) || ""
        : defaultTypeService;
      defaultTypeService =
        String(defaultTypeService || "").trim() ||
        String(Array.isArray(row?.TypeService) ? row.TypeService?.[0] : row?.TypeService ?? "").trim();

      setisLoadingtask(true);
      try {
        const manualOnly =
          filteredRows?.filter((r) => !isHardwareManagerTrainingExpenseUiRow(r)) || [];
        const formdata = manualOnly.map((r) => ({
          description: r.description,
          notes: r.notes,
          typeservice: r.typeservice || defaultTypeService,
          value: r.value,
          taskstatus: "submit",
          tripduration:
            numericValue ??
            r.tripduration ??
            filteredRows[0]?.tripduration ??
            "",
        }));

        const mergedFlat = mergeTrainingExpenseRowsInto(
          formdata || [],
          resourceTrainingBundles
        ).map((entry) =>
          normalizeDescriptionTaskWireEntry({
            ...entry,
            tripduration:
              entry?.tripduration ??
              numericValue ??
              filteredRows[0]?.tripduration ??
              "",
          })
        );

        await dispatch(
          replaceAllDescriptionTasks({
            projectid: row._id,
            taskownerid: currentAssignperson,
            tasktype: "other",
            entries: mergedFlat,
          })
        );
      } catch (error) {
        console.error("Operation failed:", error);
      } finally {
        setisLoadingtask(false);
        dispatch(fetchDescriptionTasks());
      }
    },
    [
      dispatch,
      currentAssignperson,
      setisLoadingtask,
      row,
      triprows,
      employees,
      projects,
      mytrainings,
      selectedemail,
      opemail,
      managerOPProject,
    ]
  );

  const handleAddHardware = () => {
    if (hardware?.length < 15) {
      setHardware([
        ...hardware,
        {
          assemblepartdescription: "",
          partno: "",
          quantity: "",
          unitprice: "",
          totalprice: "",
        },
      ]);
      resetTypingTimeout();
    }
  };

  const handleRemoveHardware = () => {
    const newHardware = [...hardware];
    newHardware.pop();
    setHardware(newHardware);
    setTimeout(() => {
      handlehardCostsAutoSubmitByManager(newHardware);
    }, 2000);
  };

  const handlehardwareInputChange = (index, key, value) => {
    let updated;
    setHardware((prev) => {
      updated = [...prev];

      // If changing description, find matching hardware data
      if (key === "assemblepartdescription") {
        const selectedPart = fetchedHardwareData?.find(
          (item) => item.assemblepartdescription === value
        );

        if (selectedPart) {
          updated[index] = {
            ...updated[index],
            assemblepartdescription: selectedPart.assemblepartdescription,
            partno: selectedPart.partnumber,
            unitprice: selectedPart.unitprice.toString(),
            quantity: "", // Reset quantity to empty
            totalprice: "", // Reset total price since quantity is empty
          };
        } else {
          updated[index] = {
            ...updated[index],
            [key]: value,
            partno: "",
            unitprice: "",
            quantity: "", // Reset quantity to empty
            totalprice: "", // Reset total price
          };
        }
      }
      // If changing quantity, recalculate total
      else if (key === "quantity") {
        const quantity = Number(value);
        const unitprice = Number(updated[index].unitprice || 0);

        updated[index] = {
          ...updated[index],
          quantity: value,
          totalprice:
            quantity && !isNaN(quantity)
              ? (unitprice * quantity).toFixed(2)
              : "0.00",
        };

        // Check stock availability when quantity is entered (same as Self option)
        if (updated[index].assemblepartdescription && quantity > 0) {
          const matchingInventory = inventory.find(
            (item) =>
              isInventoryGroupMatch(item) &&
              item.assembly &&
              item.assembly.trim().toLowerCase() === updated[index].assemblepartdescription.trim().toLowerCase()
          );

          if (matchingInventory) {
            const availableStock = Number(matchingInventory.unitsAvailable || 0);
            if (quantity > availableStock) {
              enqueueSnackbar("Insufficient Stock", {
                variant: "error",
              });
            }
          }
        }
      }
      // For other fields
      else {
        updated[index] = {
          ...updated[index],
          [key]: value,
        };
      }

      return updated;
    });

    // Reset and set timeout for auto-save
    if (typingTimeout) clearTimeout(typingTimeout);
    setTypingTimeout(
      setTimeout(() => {
        handlehardCostsAutoSubmitByManager(updated);
      }, 3000)
    );
  };
  const handleSelectOpen = () => {
    resetTypingTimeout();
  };

  const handlehardCostsAutoSubmitByManager = React.useCallback(
    async (newHardware) => {
      const filteredEmployee = employees.find(
        (emp) => emp?.EmpEmail === selectedemail
      );

      const updatedHardware = newHardware?.map((item) => ({
        ...item,
        taskstatus: "auto-save",
      }));
      console.log(
        "handlehardCostsAutoSubmitByManager newHardware autosace",
        updatedHardware
      );
      const payload = {
        projectid: row._id,
        tasktype: "other",
        taskownerid: filteredEmployee?._id,
        tasks: updatedHardware,
      };
      setisLoadingtask(true);
      try {
        // Update with tasktype "other" (manager's update for resource)
        await dispatch(replaceAllHardwareDescriptions(payload));
        // REMOVED: Don't update "self" when submitting for a resource
        // This was causing manager's own response to be overwritten
      } catch (error) {
        console.error("Error transforming hardware data:", error);
      } finally {
        setisLoadingtask(false);
        dispatch(fetchHardware());
      }
    },
    [row, dispatch, setisLoadingtask, employees, selectedemail]
  );

  const handlehardCostsSubmitByManager = React.useCallback(async () => {
    const hasEmptyFields = hardware.some((item) => {
      return (
        !item.assemblepartdescription ||
        !item.partno ||
        !item.quantity ||
        !item.totalprice ||
        !item.unitprice
      );
    });

    if (hasEmptyFields) {
      return;
    }
    
    const filteredEmployee = employees.find(
      (emp) => emp?.EmpEmail === selectedemail
    );

    const updatedHardware = hardware.map((item) => ({
      ...item,
      taskstatus: "submit",
    }));

    console.log(
      "handlehardCostsAutoSubmitByManager newHardware submit",
      updatedHardware
    );

    const payload = {
      projectid: managerOPProject?._id,
      tasktype: "other",
      taskownerid: filteredEmployee?._id,
      tasks: updatedHardware,
    };
    setisLoadingtask(true);
    try {
      await dispatch(replaceAllHardwareDescriptions(payload));
      // REMOVED: Don't update "self" when submitting for a resource
      // This was causing manager's own response to be overwritten
    } catch (error) {
      console.error("Error transforming hardware data:", error);
    } finally {
      setisLoadingtask(false);
      dispatch(fetchHardware());
      handlerefresh();
    }
  }, [
    hardware,
    handlerefresh,
    dispatch,
    setisLoadingtask,
    managerOPProject?._id,
    employees,
    selectedemail,
  ]);

  const resetTypingTimeout = useCallback(() => {
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }
    const newTimeout = setTimeout(() => {
      handlehardCostsAutoSubmitByManager();
    }, 3000);
    setTypingTimeout(newTimeout);
  }, [typingTimeout, handlehardCostsAutoSubmitByManager]);

  const updatebyname = useCallback(async () => {
    // Update task status for the selected person (self or operation person).
    // When manager submits for an operation person, call updateTaskStatus with that OP's userid so status changes to submit.
    const updatedAssignedperson = (row.Assignedperson || [])
      .filter((person) => person.email === selectedemail)
      .map((person) => ({
        ...person,
        taskStatus: "submit",
      }));
    const filteredEmployee = employees.find(
      (emp) => emp?.EmpEmail === updatedAssignedperson[0]?.email
    );
    const selectedProjectId = row?._id;
    const SelectedUserId = filteredEmployee?._id;
    if (!SelectedUserId || !selectedProjectId) {
      dispatch(getAllAutoSaveWorkentries());
      handlerefresh();
      return;
    }
    setisLoadingtask(true);

    try {
      await dispatch(
        updateTaskStatus({
          projectid: selectedProjectId,
          userid: SelectedUserId,
        })
      );
    } catch (error) {
      console.error("Operation failed:", error);
    } finally {
      dispatch(getAllAutoSaveWorkentries());
      handlerefresh();
      setisLoadingtask(false);
    }
  }, [dispatch, selectedemail, handlerefresh, employees, row]);

  const handleAction = async () => {
    SetisLoading(true);
    await handledirectSubmit();
    await handleDescriptionSubmit(triprows);
    await handleinstallationtaskSubmit(tripduration, triprows);
    await handlehardCostsSubmitByManager();
    await updatebyname();
    SetisLoading(false);
    enqueueSnackbar("Response Submitted Successfully.", {
      variant: "success",
    });
    setSelectedActions({});
  };
  return (
    <>
      {isLoading ? <AdminLoader isLoading={isLoading} /> : <> </>}
      <div
        className={`bg-white custom-scroll w-full ${taskTableRowId === row?._id ? "min-h-[20vh]" : ""
          } max-h-[53vh] overflow-auto pb-2`}
      >
        {(Array.isArray(selectedServiceType)
          ? selectedServiceType.some((service) => service.includes("Hardware"))
          : selectedServiceType?.includes("Hardware")) &&
          hardwareAction === "hardwarecost" && (
            <div className="mainhardwarekdiv w-full bg-white">
              <div className="w-full bg-white rounded-lg h-full justify-center">
                {/* Table Header */}
                <div className="flex flex-col w-full">
                  <div className="w-full flex flex-col">
                    <div className="head flex text-center bg-blue-500 text-white text-xs">
                      <div className="w-[10%] border p-1 flex justify-center align-middle items-center">
                        Sr. No
                      </div>
                      <div className="w-60 border py-1 break-words whitespace-normal">
                        Assembly/Part Description
                      </div>
                      <div className="w-[20%] border p-1">Part No</div>
                      <div className="w-[20%] border p-1">Quantity</div>
                      <div className="w-[20%] border p-1">
                        Unit Cost ({currency})
                      </div>
                      <div className="w-[20%] border p-1">
                        Total Cost ({currency})
                      </div>
                    </div>
                    <div className="head flex text-center bg-blue-500  text-white text-[11px]">
                      <div className=" border w-[10%] p-1 break-all whitespace-normal"></div>
                      <div className=" border w-60 pt-1  break-all whitespace-normal">
                        Total
                      </div>
                      <div className=" border w-[20%] break-all whitespace-normal  p-1">
                        {" "}
                      </div>
                      <div className=" border w-[20%]  break-all whitespace-normal p-1"></div>
                      <div className=" border w-[20%]  break-all whitespace-normal p-1">
                        {" "}
                      </div>
                      <div className=" border w-[20%]  break-all whitespace-normal p-1">
                        {USAComma(
                          hardware?.reduce((sum, item) => {
                            return sum + Number(item.totalprice);
                          }, 0)
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="w-full">
                  {hardware?.map((row, index) => {
                    console.log("OperationHardware hardware", hardware)
                    return (
                      <React.Fragment key={index}>
                        {Assignperson?.taskStatus === "submit" ? (
                          <div className="flex items-center text-center w-full text-xs">
                            <div className="w-full">
                              <div className="head flex">
                                <div className="w-[10%] border p-1">
                                  {index + 1}
                                </div>

                                {/* Description Select */}
                                <div className="w-60  border p-1 break-all whitespace-normal">
                                  {row.assemblepartdescription || ""}
                                </div>

                                {/* Part Number */}
                                <div className="w-[20%] border p-1 break-all whitespace-normal">
                                  {row.partno || ""}
                                </div>

                                {/* Quantity Input */}
                                <div className="w-[20%] border p-1 break-all whitespace-normal">
                                  {row.quantity || ""}
                                </div>

                                {/* Unit Price */}
                                <div className="w-[20%] border p-1 break-all whitespace-normal">
                                  {USAComma(row.unitprice) || ""}
                                </div>

                                {/* Total Price */}
                                <div className="w-[20%] border p-1 break-all whitespace-normal">
                                  {USAComma(row.totalprice || "")}
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="flex items-center text-center w-full text-xs">
                            <div className="w-full">
                              <div className="head flex">
                                <div className="w-[10%] border p-1">
                                  {index + 1}
                                </div>

                                {/* Description Select */}
                                <div className="w-60  border p-1 break-all whitespace-normal">
                                  <select
                                    name="assemblepartdescription"
                                    value={row.assemblepartdescription || ""}
                                    onChange={(e) =>
                                      handlehardwareInputChange(
                                        index,
                                        "assemblepartdescription",
                                        e.target.value
                                      )
                                    }
                                    onFocus={handleSelectOpen}
                                    className="outline-none bg-white text-black border-none text-center w-full h-full"
                                  >
                                    <option hidden value="">
                                      Select
                                    </option>
                                    {fetchedHardwareData?.map((option) => {
                                      const isAlreadySelected = hardware.some(
                                        (row, i) =>
                                          row.assemblepartdescription ===
                                          option.assemblepartdescription &&
                                          i !== index
                                      );

                                      return (
                                        <option
                                          key={option._id}
                                          value={option.assemblepartdescription}
                                          disabled={isAlreadySelected}
                                        >
                                          {option.assemblepartdescription}
                                        </option>
                                      );
                                    })}
                                  </select>
                                </div>

                                <div className="w-[20%] border p-1 break-all whitespace-normal">
                                  {row.partno || ""}
                                </div>

                                <div className="w-[20%] border p-1 break-all whitespace-normal">
                                  <input
                                    type="number"
                                    placeholder="enter quantity"
                                    value={row.quantity || ""}
                                    onChange={(e) => {
                                      let value = e.target.value;

                                      // ✅ Only numbers with up to 3 decimal places
                                      if (
                                        /^\d*\.?\d{0,3}$/.test(value) ||
                                        value === ""
                                      ) {
                                        handlehardwareInputChange(
                                          index,
                                          "quantity",
                                          value
                                        );
                                      }
                                    }}
                                    onKeyDown={(e) => {
                                      if (
                                        !(
                                          (e.key >= "0" && e.key <= "9") || // numbers
                                          e.key === "." || // decimal
                                          e.key === "Backspace" ||
                                          e.key === "Delete" ||
                                          e.key === "ArrowLeft" ||
                                          e.key === "ArrowRight" ||
                                          e.key === "Tab"
                                        )
                                      ) {
                                        e.preventDefault();
                                      }
                                    }}
                                    className="w-full h-full border text-center border-gray-300 rounded-md p-0.5"
                                  />
                                </div>

                                <div className="w-[20%] border p-1 break-all whitespace-normal">
                                  {USAComma(row.unitprice) || ""}
                                </div>

                                <div className="w-[20%] border p-1 break-all whitespace-normal">
                                  {USAComma(row.totalprice || "")}
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </React.Fragment>
                    )
                  })}

                  {Assignperson?.taskStatus === "submit" ? (
                    <></>
                  ) : (
                    <div className="flex justify-between px-2 pt-1">
                      <button
                        className="shadow-xl rounded-md p-1"
                        onClick={handleAddHardware}
                        disabled={hardware.length >= 15}
                      >
                        <AddIcon />
                      </button>
                      <button
                        className="shadow-xl rounded-md p-1"
                        onClick={handleRemoveHardware}
                      >
                        <RemoveIcon />
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

        {((Array.isArray(selectedServiceType)
          ? selectedServiceType.some((service) => service.includes("Hardware"))
          : selectedServiceType?.includes("Hardware")) &&
          hardwareAction === "otherexpenses") ||
          ((selectedServiceType?.includes("Software") ||
            selectedServiceType?.includes("Cloud")) &&
            Action === "otherExpenses") ? (
          <div className="maintaskdiv w-full bg-white">
            <div className="w-full bg-white rounded-lg h-full justify-center">
              <div className="flex flex-col w-full">
                <div className="w-full">
                  <div className="head flex text-center bg-blue-500 text-white text-xs">
                    <div className="w-[10%] border p-1 flex justify-center align-middle items-center">
                      Sr. No
                    </div>
                    <div className="w-[40%] border p-2">Description</div>
                    <div className="w-[25%] border p-2">
                      Amount ({currency})
                    </div>
                    <div className="w-[25%] border p-2">Notes</div>
                  </div>
                </div>
                <div className="w-full">
                  <div className="head flex text-center  text-xs">
                    <div className="w-[10%] border p-1 flex justify-center align-middle items-center"></div>
                    <div className="w-[40%] border p-2">Total</div>
                    <div className="w-[25%] border p-2">
                      {formatAmountComma(totalDollerValue)}
                    </div>
                    <div className="w-[25%] border p-2"></div>
                  </div>
                </div>
              </div>
              <div className="w-full">
                {triprows.map((expRow, index) => {
                  const isTrainingRow = isHardwareManagerTrainingExpenseUiRow(expRow);
                  const inputCls =
                    "outline-none border-none text-center w-full h-full bg-transparent rounded-md px-1" +
                    (isTrainingRow ? " text-[#6b7280] cursor-not-allowed" : "");
                  const rowFragKey = expRow._id
                    ? `trip-${String(expRow._id)}-${index}`
                    : `trip-row-${index}`;

                  return (
                    <React.Fragment key={rowFragKey}>
                      {Assignperson?.taskStatus === "submit" ? (
                        <div
                          className="flex items-center text-center w-full text-xs"
                          style={isTrainingRow ? trainingExpenseRowSurfaceStyle : undefined}
                        >
                          <div className="w-full">
                            <div className="head flex">
                              <div className="w-[10%] border p-1">
                                {index + 1}
                              </div>

                              <div className="w-[40%] border p-2">
                                {expRow.description || ""}
                              </div>

                              <div className="w-[25%] border p-2">
                                {formatAmountComma(expRow.value || "")}
                              </div>

                              <div className="w-[25%] border p-2">
                                {isTrainingRow ? "" : expRow.notes || ""}
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div
                          className="flex items-center text-center w-full text-xs"
                          style={isTrainingRow ? trainingExpenseRowSurfaceStyle : undefined}
                        >
                          <div className="w-full">
                            <div className="head flex">
                              <div className="w-[10%] border p-1">
                                {index + 1}
                              </div>

                              <div className="w-[40%] border p-2">
                                <input
                                  type="text"
                                  name="description"
                                  disabled={isTrainingRow}
                                  readOnly={isTrainingRow}
                                  value={expRow.description || ""}
                                  onChange={(e) =>
                                    handleTripInputChange(
                                      index,
                                      "description",
                                      e.target.value
                                    )
                                  }
                                  placeholder="Enter Description"
                                  className={inputCls}
                                />
                              </div>

                              <div className="w-[25%] border p-2">
                                <input
                                  type="text"
                                  name="value"
                                  disabled={isTrainingRow}
                                  readOnly={isTrainingRow}
                                  value={formatAmountForInput(expRow.value || "")}
                                  onChange={(e) =>
                                    handleTripInputChange(
                                      index,
                                      "value",
                                      validateAmountValue(e.target.value)
                                    )
                                  }
                                  onKeyDown={(e) => {
                                    if (["e", "E", "+", "-"].includes(e.key)) {
                                      e.preventDefault();
                                    }
                                  }}
                                  className={inputCls}
                                />
                              </div>

                              <div className="w-[25%] border p-2">
                                <input
                                  type="text"
                                  name="notes"
                                  disabled={isTrainingRow}
                                  readOnly={isTrainingRow}
                                  value={isTrainingRow ? "" : expRow.notes || ""}
                                  onChange={(e) =>
                                    handleTripInputChange(index, "notes", e.target.value)
                                  }
                                  placeholder="Enter Notes"
                                  className={inputCls}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                    </React.Fragment>
                  );
                })}

                {Assignperson?.taskStatus === "submit" ? null : (
                  <div className="flex justify-between px-2 pt-1">
                    <button
                      className="shadow-xl rounded-md p-1"
                      onClick={handleAddRow}
                      disabled={triprows.length >= 15}
                    >
                      <AddIcon />
                    </button>
                    <button
                      className="shadow-xl rounded-md p-1"
                      onClick={() => handleRemoveRow(lastEditableTripRowIndex)}
                      disabled={lastEditableTripRowIndex < 0}
                    >
                      <RemoveIcon />
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        ) : null}

        {Assignperson?.taskStatus === "submit" ? (
          <></>
        ) : (
          <div className="flex justify-end py-1 gap-1">
            {isLoadingtask && (
              <div className="mt-4 flex gap-1 align-middle items-center">
                <div className="text-sm">Saving Tasks </div>
                <SubmitLoader isLoadingtask={isLoadingtask} />
              </div>
            )}
            {(() => {
              const hasValidHardwareEntry = hardware.some(
                (item) =>
                  (item.assemblepartdescription && String(item.assemblepartdescription).trim() !== "") &&
                  item.quantity &&
                  Number(item.quantity) > 0
              );
              const canShowSubmit = filteredEntries?.length > 0 || hasValidHardwareEntry;
              return canShowSubmit ? (
                <button
                  onClick={() => handleAction()}
                  className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-md"
                >
                  Submit
                </button>
              ) : null;
            })()}
          </div>
        )}
      </div>
    </>
  );
};

export default OperationHardware;
